// extracted by mini-css-extract-plugin
module.exports = {"heading":"EditableHeading_heading__3p4B1"};